import { render, staticRenderFns } from "./CapaProcesso.vue?vue&type=template&id=a767a7d8&scoped=true&"
import script from "./CapaProcesso.vue?vue&type=script&lang=js&"
export * from "./CapaProcesso.vue?vue&type=script&lang=js&"
import style0 from "./CapaProcesso.vue?vue&type=style&index=0&id=a767a7d8&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a767a7d8",
  null
  
)

export default component.exports